module.exports = __webpack_public_path__ + "img/ed3ca27.png";